module.exports = __webpack_public_path__ + "img/icon-warning-jordskred-2.5b26d862.svg";